import { Injectable } from '@angular/core';
import { InvoiceDto } from '../dtos/invoice.dto';
import { Invoice } from '../../domain/models/invoice.model';

// Deliberate, small duplication of `features/clients/data/mappers/invoice.mapper.ts` (same
// mapping logic) -- the `patients` feature cannot import from `features/clients` (see
// `tools/check-architecture.mjs`'s cross-feature-import rule).
@Injectable()
export class InvoiceMapper {
  public toInvoice(dto: InvoiceDto): Invoice {
    return {
      id: dto.ExternalId,
      number: dto.InvoiceNumber ?? null,
      patientNames: dto.PatientNames,
      date: dto.InvoiceDate ?? null,
      total: dto.TotalWithVat ?? null,
      isPending: dto.IsPending,
    };
  }
}
